import React, { useContext, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import FormatDate from '../../Utils/FormatDate';
import classes from './styles.module.css';
import Context from '../../../Context';

function TableRow({ data = {}, currentUuid }) {
    const { onSelectProjectUuid } = useContext(Context);

    // --- Аккаунты: поддержка строк и объектов ---
    const accountsText = useMemo(() => {
        const list = Array.isArray(data.accounts) ? data.accounts : [];
        if (!list.length) return '-';
        const names = list
            .map(function (a) {
                if (typeof a === 'string') return a;
                if (a && typeof a === 'object') {
                    if (a.username && typeof a.username === 'string') return a.username;
                    if (a.name && typeof a.name === 'string') return a.name;
                }
                return '';
            })
            .filter(function (x) {
                return x;
            });
        return names.length ? names.join(', ') : '-';
    }, [data.accounts]);

    // --- Статус: поддержка чисел и i18n-ключей ---
    let statusId, statusDefault, color;

    if (typeof data.status === 'string') {
        switch (data.status) {
            case 'Status.active':
                statusId = 'Status.active';
                statusDefault = 'Активен';
                color = 'rgb(16,150,24)';
                break;
            case 'Status.inactive':
                statusId = 'Status.inactive';
                statusDefault = 'Не активна';
                color = '#ff9900';
                break;
            case 'Status.blocked':
                statusId = 'Status.blocked';
                statusDefault = 'Заблокирован';
                color = 'rgb(220,57,18)';
                break;
            default:
                statusId = 'Status.unknown';
                statusDefault = 'Неизвестно';
                color = '#999';
        }
    } else {
        switch (data.status) {
            case 1:
                statusId = 'AccountsList.status.active';
                statusDefault = 'Активен';
                color = 'rgb(16,150,24)';
                break;
            case -1:
                statusId = 'AccountsList.status.inactive';
                statusDefault = 'Не активна';
                color = '#ff9900';
                break;
            case -2:
                statusId = 'AccountsList.status.closed';
                statusDefault = 'Закрыт';
                color = '#d4d4d4';
                break;
            case -3:
                statusId = 'AccountsList.status.blocked';
                statusDefault = 'Заблокирован';
                color = 'rgb(220,57,18)';
                break;
            default:
                statusId = 'Status.unknown';
                statusDefault = 'Неизвестно';
                color = '#999';
        }
    }

    const isActive = currentUuid === data.uuid;
    const rowStyle = isActive ? { backgroundColor: '#e3f2fd' } : undefined;

    return (
        <tr
            style={rowStyle}
            className={classes.Row}
            onClick={() => data.uuid && onSelectProjectUuid && onSelectProjectUuid(data.uuid)}
        >
            <td className={classes.CellCenter}>
                <FormatDate
                    setDate={data.createdAt}
                    format={{ day: 'numeric', month: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric' }}
                />
            </td>
            <td className={classes.Cell}>{data.name || '-'}</td>
            <td className={classes.Cell}>{data.url || '-'}</td>
            <td className={classes.Cell}>{accountsText}</td>
            <td className={classes.CellCenter}>
                <span style={{ color: color }}>
                    <FormattedMessage id={statusId} defaultMessage={statusDefault} />
                </span>
            </td>
        </tr>
    );
}

export default TableRow;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/ProjectsList/TableRow.js